module.exports = __webpack_public_path__ + "static/img/about-img.77fed6fd.jpg";